import points from "../services/points";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        message: null,
        loading: true,
        auth: {},
        details: {},
        mechanicsList: [],
        pointsMechanicsList: {},
        errors: {},
        analytics: {
            sales: {
                lifetimeSales: null,
                revenueSales: null,
                averageOrderValue: null,
                rateChangeYear: 0
            },
            acquisition: {
                registeredUsers: null,
                dailyAverage: null,
                rateChange: null,
                rateChangeYear: 0
            },
            engagement: {
                lifetimeSms: null,
                dailyAverage: null,
                rateChange: null,
                rateChangeYear: 0
            },
            rewards: {
                redeemed: null,
                issued: null,
                rateChange: null,
                rateChangeYear: 0
            },
            salesOverview: {
                sales: null,
                revenue: null,
                givenPoints: null,
                usedPoints: null
            },
            branchItems: [],
            rewardItems: [],
            chartData: null
        }
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        getDetails(state, details) {
            state.details = details;
        },
        setMechanicsList(state, value) {
            state.mechanicsList = value;
        },
        setPointsMechanicsList(state, pointsMechanicsList) {
            state.pointsMechanicsList = pointsMechanicsList;
            state.loading = false;
        },
        setPointsMechanicsList(state, pointsMechanicsList) {
            state.pointsMechanicsList = pointsMechanicsList;
            state.loading = false;
        },
        updateDetails(state, data) {
            state.message = data.message;
            state.details = data.mechanics;
            state.loading = false;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setVoidDetails(state, data) {
            state.details.customer_uuid = data.customer_uuid;

            let reference = {
                transaction_no: data.details,
                transaction_uuid: data.transaction_uuid
            };

            state.details.action = data.transaction_status_type;
            state.details.reference = JSON.stringify(reference);

            // let actionStr = data.transaction_status_type;
            // actionStr = actionStr.replace(/\s+/g, '-');
            // actionStr = actionStr.toLowerCase().trim();
            // state.details.action = actionStr;
        },
        setAnalytics(state, data) {
            state.analytics.sales.lifetimeSales = data.sales.lifetimeSales;
            state.analytics.sales.revenueSales = data.sales.revenueSales;
            state.analytics.sales.averageOrderValue =
                data.sales.averageOrderValue;
            state.analytics.sales.rateChangeYear = data.sales.rateChangeYear;
            state.analytics.acquisition.registeredUsers =
                data.acquisition.registeredUsers;
            state.analytics.acquisition.dailyAverage =
                data.acquisition.dailyAverage;
            state.analytics.acquisition.rateChange =
                data.acquisition.rateChange;
            state.analytics.acquisition.rateChangeYear =
                data.acquisition.rateChangeYear;
            state.analytics.engagement.lifetimeSms =
                data.engagement.lifetimeSms;
            state.analytics.engagement.dailyAverage =
                data.engagement.dailyAverage;
            state.analytics.engagement.rateChange = data.engagement.rateChange;
            state.analytics.engagement.rateChangeYear =
                data.engagement.rateChangeYear;
            state.analytics.rewards.redeemed = data.rewards.redeemed;
            state.analytics.rewards.issued = data.rewards.issued;
            state.analytics.rewards.rateChange = data.rewards.rateChange;
            state.analytics.rewards.rateChangeYear =
                data.rewards.rateChangeYear;
            state.analytics.salesOverview.sales = data.salesOverview.sales;
            state.analytics.salesOverview.revenue = data.salesOverview.revenue;
            state.analytics.salesOverview.givenPoints =
                data.salesOverview.givenPoints;
            state.analytics.salesOverview.usedPoints =
                data.salesOverview.usedPoints;
        },
        setBranchItems(state, data) {
            state.analytics.branchItems = data;
        },
        setRewardItems(state, data) {
            state.analytics.rewardItems = data;
        },

        setChartData(state, data) {
            state.analytics.chartData = data;
            this.isReady = true;
        }
    },
    actions: {
        getDetails: async ({ commit }) => {
            commit("loading");

            try {
                let response = await points.getDetails();
                commit("getDetails", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        getPointsRulesList: async ({ commit }) => {
            commit("loading", true);

            try {
                const response = await points.getPointsRulesList();

                commit("setMechanicsList", response.list);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        getPointsMechanicsList: async ({ commit }) => {
            commit("loading");
            try {
                let response = await points.getPointsMechanicsList();
                commit("setPointsMechanicsList", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        // updateDetails: async ({ commit, state }) => {
        //     commit("loading");
        //     try {
        //         let response = await points.getPointsMechanicsList();
        //         commit("setPointsMechanicsList", response.list);
        //         commit("loading", false);
        //     } catch (errors) {
        //         commit("errors", errors);
        //         commit("loading", false);
        //     }
        // },
        updateDetails: async ({ commit, state }) => {
            commit("loading");
            commit("errors", {});

            try {
                let response = await points.updateDetails({
                    description: state.details.description,
                    amount: state.details.amount,
                    points: state.details.points,
                    currency: state.details.currency,
                    redeem_amount: state.details.redeem_amount,
                    redeem_points: state.details.redeem_points,
                    redeem_currency: state.details.redeem_currency,
                    transfer_points: state.details.transfer_points,
                    validity: state.details.validity,
                    expiration: state.details.expiration,
                    max_points: state.details.max_points,
                    or_required: state.details.or_required
                });

                notification.success(response.message);
                commit("updateDetails", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        updateStandardPointsRules: async ({ commit }, payload) => {
            commit("loading", true);
            commit("errors", {});

            try {
                const response = await points.updateStandardPointsRules(
                    payload
                );

                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(
                    "Oops, cannot update standard points rules."
                );
            } finally {
                commit("loading", false);
            }
        },
        createCustomPointsRules: async ({ commit }, payload) => {
            commit("loading", true);
            commit("errors", {});

            try {
                const response = await points.createCustomPointsRules(payload);

                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(
                    "Oops, cannot create custom points rules."
                );
            } finally {
                commit("loading", false);
            }
        },
        updateCustomPointsRules: async ({ commit }, payload) => {
            commit("loading", true);
            commit("errors", {});

            try {
                const response = await points.updateCustomPointsRules(payload);

                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(
                    "Oops, cannot update custom points rules."
                );
            } finally {
                commit("loading", false);
            }
        },
        voidDeduction: async ({ commit }, param) => {
            commit("loading");
            try {
                let response = await points.voidDeduction(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(errors.message);
                commit("errors", errors);
                commit("loading", false);
            }
        },
        getAnalyticsA: async ({ commit }, param) => {
            try {
                let merchant_uuid = param.merchant_uuid;
                let response = await points.getAnalyticsA(merchant_uuid);
                let sales = response;
                commit("setAnalytics", sales);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        getBranchItems: async ({ commit }, param) => {
            try {
                let merchant_uuid = param.merchant_uuid;
                let response = await points.getBranchItems(merchant_uuid);
                commit("setBranchItems", response);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        getRewardItems: async ({ commit }, param) => {
            try {
                let merchant_uuid = param.merchant_uuid;
                let response = await points.getRewardItems(merchant_uuid);
                commit("setRewardItems", response);
            } catch (errors) {
                commit("errors", errors);
            }
        },

        getChartData: async ({ commit }, param) => {
            try {
                let merchant_uuid = param.merchant_uuid;
                let selectedDays = param.selectedDays;
                let anchorDate = param.anchorDate;
                let response = await points.getChartData(
                    merchant_uuid,
                    anchorDate,
                    selectedDays
                );
                commit("setChartData", response);
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
};
